import { SidebarPanelProps } from "../../../../../types/product";
import Tag from "../../../../common/UI/Tag";

export default function SerpPreviewPanel({ form }: SidebarPanelProps) {
    const slug = (form.tab_name || "").toLowerCase().replace(/\s+/g, "-") || "product";
    const hasContent = form.meta_title || form.meta_description;
    return (
        <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 14, overflow: "hidden" }}>
            <div style={{
                display: "flex", alignItems: "center", gap: 10, padding: "14px 20px",
                borderBottom: "1px solid var(--border)", background: "var(--section-header)",
            }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: "var(--text)", flex: 1 }}> SEO Search Preview</span>
                <Tag>Live</Tag>
            </div>
            <div style={{ padding: 16 }}>
                {hasContent ? (
                    <div style={{
                        background: "rgba(255,255,255,0.03)", border: "1px solid var(--border)",
                        borderRadius: 10, padding: "14px 16px",
                    }}>
                        <div style={{ fontSize: 15, color: "#8ab4f8", fontWeight: 400, marginBottom: 3, lineHeight: 1.35 }}>
                            {form.meta_title || "Untitled Page"}
                        </div>
                        <div style={{ fontSize: 12, color: "#34a853", marginBottom: 6 }}>
                            auralglobal.com › products › {slug}
                        </div>
                        <div style={{ fontSize: 13, color: "#bdc1c6", lineHeight: 1.6 }}>
                            {form.meta_description || "No meta description provided."}
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: "center", padding: "20px 0", color: "var(--text3)", fontSize: 13 }}>
                        Fill in the meta fields to see a live preview
                    </div>
                )}
            </div>
        </div>
    );
}
